export const ROOT_NAV_ICONS = [
  {
    id: 1000,
    route: 'dashboard',
    icon: 'icon-home-c',
  },
  {
    id: 1001,
    route: 'contracts',
    icon: 'icon-task-edit-c',
  },
  {
    id: 1002,
    route: 'manage',
    icon: 'icon-manage-c',
  },
  {
    id: 1003,
    route: 'revenues',
    icon: 'icon-money-c',
  },
  {
    id: 1004,
    route: 'costs',
    icon: 'icon-dollar-c',
  },
  {
    id: 1005,
    route: 'reports',
    icon: 'icon-report-c',
  },
  {
    id: 1006,
    route: 'analytics',
    icon: 'icon-analytics-c',
  },
  {
    id: 1007,
    route: 'audits',
    icon: 'icon-audit-c',
  },
  {
    id: 1008,
    route: 'settings',
    icon: 'icon-settings-c',
  },
];
